import api from 'api'

export type ShiftRoster = {
  rosterHoldExpiresAt: string | null
}

export const getShiftRosterByShiftId = async (
  shiftId: number
): Promise<ShiftRoster> => {
  const response = await api.get<ShiftRoster>(`/admin/shift/${shiftId}/roster`)

  return response.data
}
